import * as React from 'react';
import styled from 'styled-components';
import { ImageType } from '../../../server/global/enum';

import { Image } from '../ui/Image';

export const CardImageStyle = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
`;

export const CardImage: React.FC<{
  image: string;
  description?: string;
  style?: any;
  type?: string;
}> = ({ image, description, style, type }) => {
  return <Image url={image} style={style} type={type} />;
};
